/**
 * Instagram-inspired color palette for VibeChat.
 * These are the raw color values. Semantic tokens are in foundations/.
 */
const colors = {
  brand: {
    purple: "#833AB4",
    pink: "#E1306C",
    orange: "#F77737",
    // Gradient string for use in bgGradient prop
    gradient: "linear(to-br, #833AB4, #E1306C, #F77737)",
  },
};

export default colors;
